import React from 'react'
import {connect} from 'react-redux'

import getUserSessionsCount from './data/getters/user_sessions_count'

class ExpertSessionsCount extends React.Component {
  componentWillMount () {
    this.props.onComponentLoaded(this.props.uid)
  }

  render () {
    if (this.props.sessionsCount) {
      return (
        <div className='expert-sessions-count' style={{marginLeft: this.props.marginLeft, fontSize: this.props.size}}>
          <i className='rc-icon-session-count'/>
          <span>{this.props.sessionsCount}</span>
        </div>
      )
    }
    else {
      return false
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    sessionsCount: state.getIn(['sessions', '_counts', ownProps.uid])
  }
}

const mapDispatchToProps = () => {
  return {
    onComponentLoaded: getUserSessionsCount
  }
}

const ExpertSessionsCountContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ExpertSessionsCount)

export default ExpertSessionsCountContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/expert_sessions_count.js
 **/